//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['photoCodeBool','isDisabled'],
    directives: {
        focus: {
            componentUpdated: function (el, obj) {
                obj.value && el.focus()
            }
        }
    },
    created () {
        this.code = new Array(this.amount).fill('')
    },
    data () {
        return {
            code: [],
            currentIndex: 0,
            currentcode:null,
            amount: 6
        }
    },
    computed:{
        isPhotoCode(){
            return this.photoCodeBool;
        }
    },
    methods: {
        bothCode(e,index){
            this.code[index-1] = e.target.value
            if(this.currentcode && this.currentcode.length === 6){
                this.$parent.verPhotoCode() //父组件位数实施检验
            }
        },
        aa(){
            this.code = []
            this.currentIndex = 0
        },
        handleInput (e, index) {
            this.currentIndex = index
            e.target.value = this.validateNumber(e.target.value)
            e.target.value !== '' && ++this.currentIndex
            let code = this.code.join('');
            this.currentcode = code
            this.$parent.getPhotoCode(code)
        },
        onDelete (e, index) {
            this.code[index] = e.target.value
            if (e.target.value === '') {
                this.currentIndex = index - 1
            }
        },
        validateNumber (val) {
            return val.replace(/\D/g, '')
        },
        handlePaste (e) {
            e.preventDefault()
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/code/index.vue